import React from "react";
import PropTypes from "prop-types";
import { Card, Descriptions } from "antd";
import { PermissionContextManager } from "hocs";
import { UI_PERMISSIONS } from "constants";

const ListItem = Descriptions.Item;

class SupplyChainStats extends React.Component {
    render() {
        const { data } = this.props;
        return (
            <Card title={"Supply Chain Stats"} className={"padless-card"}>
                <Descriptions bordered size={"middle"} column={2}>
                    {data &&
                        data
                            .map(_ => (
                                <ListItem
                                    key={_.label}
                                    label={_.label}
                                    span={_.span || 1}
                                >
                                    {_.value || "0"}
                                </ListItem>
                            ))
                            .toList()
                            .toArray()}
                </Descriptions>
            </Card>
        );
    }
}

SupplyChainStats.propTypes = {
    data: PropTypes.object,
    isUserAllowedToEdit: PropTypes.bool
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.SUPPLY_CHAIN_VIEW
})(SupplyChainStats);
